import classNames from 'classnames';
import {
  FC,
  ReactNode,
} from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import { withSuffix } from 'src/common/utils/dataAttributeHelpers';
import Radio from '../Radio';
import { useRadio } from '../RadioContext';
import styles from './RadioButton.module.scss';
import Icon from '../../IconDS22';

type RadioButtonProps = {
  value: string | number;
  children: ReactNode;
  stretch?: boolean;
  fullWidth?: boolean;
  /** required to tab between multiple RadioGroup */
  name?: string;
  size?: 's' | 'm';
  'data-test'?: string;
  variant?: 'primary' | 'pills' | 'button';
};
const RadioButton: FC<RadioButtonProps> = ({
  value,
  children,
  stretch,
  fullWidth = false,
  name,
  size = 'm',
  variant,
  'data-test': dataTest,
}) => {
  const { value: state, focus, disabled } = useRadio();
  const isSelected = state === value;
  return (
    <Radio
      value={value}
      name={name}
      className={getClassNames(styles, 'root', classNames(`size-${size}`, variant, {
        stretch,
        fullWidth,
        selected: isSelected,
        focus: focus === value,
        disabled,
      }))}
      data-test={withSuffix(dataTest, 'radio-button')}
      disabled={disabled}
    >
      {children}
      {variant === 'button' && isSelected && (
        <Icon id="check" />
      )}
    </Radio>
  );
};

export default RadioButton;
